__turbopack_context__.v({
  "AddButton": "RFFmma_AddButton",
  "AddOptionRow": "RFFmma_AddOptionRow",
  "CheckboxField": "RFFmma_CheckboxField",
  "CheckboxLabel": "RFFmma_CheckboxLabel",
  "Field": "RFFmma_Field",
  "HelpText": "RFFmma_HelpText",
  "Input": "RFFmma_Input",
  "Label": "RFFmma_Label",
  "OptionItem": "RFFmma_OptionItem",
  "OptionLabel": "RFFmma_OptionLabel",
  "OptionValue": "RFFmma_OptionValue",
  "OptionsList": "RFFmma_OptionsList",
  "RadioGroup": "RFFmma_RadioGroup",
  "RadioLabel": "RFFmma_RadioLabel",
  "RemoveButton": "RFFmma_RemoveButton",
  "Root": "RFFmma_Root",
  "Select": "RFFmma_Select",
  "WarningText": "RFFmma_WarningText",
  "skeleton-loading": "RFFmma_skeleton-loading",
});
